<footer class="footer">
  <div class="container">
    <div class="footer-top">
      <!-- Left Section -->
      <div class="footer-logo">
        <div class="sbvhs d-flex align-items-center gap-2">
          <img src="../../../assets/logo/ias-small-logo.png" alt="IAS Association Logo" />
          <p class="org-name m-0 p-0">Indian Administrative Service <br>Central Association</p>
        </div>
        <div class="last-updated">Last updated: {{ finalDate }}</div>
      </div>

      <!-- IAS Foundation Links -->
      <div class="footer-links">
        <h4>Important Links</h4>
        <!-- <a [routerLink]="'about-us'">About Us</a> -->
        <a [routerLink]="'community'">Community</a>
        <a [routerLink]="'membership'">Membership</a>
        <a [routerLink]="'contact-us'">Contact Us</a>
      </div>

      <!-- Important Links -->
      <div class="footer-links">
        <!-- <h4>Resources</h4> -->
        <h4 >Resources</h4>
        <a [routerLink]="'news-blogs'">News</a>
        <a [routerLink]="'good-governance-initiatives'">Good Governance Initiatives</a>
      </div>

      <!-- Contact & Social -->
      <div class="footer-contact">
        <div class="social-icons">
          <!-- <a href="https://x.com/iasassociation" target="_blank"><i class="fab fa-linkedin-in"></i></a> -->
          <a href="https://x.com/iasassociation" target="_blank"><i class="fab fa-x-twitter"></i></a>
          <a href="https://www.facebook.com/IASassociation/" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <!-- <a href="#"><i class="fab fa-instagram"></i></a>
          <a href="#"><i class="fab fa-youtube"></i></a> -->
        </div>
        <div class="contact-info">
          <p class="d-flex gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
              <mask id="mask0_52081_3854" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17"
                height="18">
                <rect width="17" height="18" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_52081_3854)">
                <path
                  d="M8.50742 9C8.92164 9 9.27624 8.85313 9.57121 8.55938C9.86618 8.26563 10.0137 7.9125 10.0137 7.5C10.0137 7.0875 9.86618 6.73438 9.57121 6.44063C9.27624 6.14687 8.92164 6 8.50742 6C8.0932 6 7.73861 6.14687 7.44363 6.44063C7.14866 6.73438 7.00117 7.0875 7.00117 7.5C7.00117 7.9125 7.14866 8.26563 7.44363 8.55938C7.73861 8.85313 8.0932 9 8.50742 9ZM8.50742 14.5125C10.0388 13.1125 11.1747 11.8406 11.9153 10.6969C12.6559 9.55312 13.0262 8.5375 13.0262 7.65C13.0262 6.2875 12.59 5.17188 11.7176 4.30312C10.8452 3.43438 9.77518 3 8.50742 3C7.23966 3 6.1696 3.43438 5.29723 4.30312C4.42486 5.17188 3.98867 6.2875 3.98867 7.65C3.98867 8.5375 4.35896 9.55312 5.09953 10.6969C5.8401 11.8406 6.97607 13.1125 8.50742 14.5125ZM8.50742 16.5C6.48654 14.7875 4.97715 13.1969 3.97926 11.7281C2.98137 10.2594 2.48242 8.9 2.48242 7.65C2.48242 5.775 3.08806 4.28125 4.29934 3.16875C5.51061 2.05625 6.91331 1.5 8.50742 1.5C10.1015 1.5 11.5042 2.05625 12.7155 3.16875C13.9268 4.28125 14.5324 5.775 14.5324 7.65C14.5324 8.9 14.0335 10.2594 13.0356 11.7281C12.0377 13.1969 10.5283 14.7875 8.50742 16.5Z"
                  fill="#1C1B1F" />
              </g>
            </svg>
            <span>Indian Administrative Service <br>Central Association, New Delhi</span>
          </p>
          <div class="d-flex gap-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <mask id="mask0_52081_3844" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18"
                height="18">
                <rect width="18" height="18" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_52081_3844)">
                <path
                  d="M8.25 12.75H9.75V8.25H8.25V12.75ZM9 6.75C9.2125 6.75 9.39063 6.67812 9.53438 6.53438C9.67813 6.39062 9.75 6.2125 9.75 6C9.75 5.7875 9.67813 5.60938 9.53438 5.46562C9.39063 5.32187 9.2125 5.25 9 5.25C8.7875 5.25 8.60938 5.32187 8.46563 5.46562C8.32188 5.60938 8.25 5.7875 8.25 6C8.25 6.2125 8.32188 6.39062 8.46563 6.53438C8.60938 6.67812 8.7875 6.75 9 6.75ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9813 3.69375 14.3063C3.01875 13.6313 2.48438 12.8375 2.09063 11.925C1.69687 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69687 6.9875 2.09063 6.075C2.48438 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48438 6.075 2.09063C6.9875 1.69687 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09063C12.8375 2.48438 13.6313 3.01875 14.3063 3.69375C14.9813 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9813 13.6313 14.3063 14.3063C13.6313 14.9813 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5ZM9 15C10.675 15 12.0938 14.4187 13.2563 13.2563C14.4187 12.0938 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2563 4.74375C12.0938 3.58125 10.675 3 9 3C7.325 3 5.90625 3.58125 4.74375 4.74375C3.58125 5.90625 3 7.325 3 9C3 10.675 3.58125 12.0938 4.74375 13.2563C5.90625 14.4187 7.325 15 9 15Z"
                  fill="#1C1B1F" />
              </g>
            </svg>
            <div>
              Need help?<span class="text-muted"> Contact Help Desk:</span>
              <div class="mt-2 needlink">
                <a href="tel:+919876543210" class="d-block text-primary">[+91 9910659965]</a>
                <a href="mailto:iasca.helpdesk@zohomail.in" class="d-block text-primary">[iasca.helpdesk&#64;zohomail.in]</a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="container d-flex align-items-center justify-content-between">
      <p class="m-0">© 2024 - Indian Administrative Service Central Association. All rights reserved.</p>
      <div class="footer-policies">
        <a routerLink="Refund-Cancellation-Policy">Refund & Cancellation Policy</a>
        <a routerLink="/Terms-Conditions">Terms & Conditions</a>
        <a routerLink="/Privacy-Policy">Privacy Policy</a>
      </div>
    </div>
  </div>
</footer>